import { defineMessages } from 'react-intl';

export default defineMessages({
  name: 'Category Name',
  path: 'Parent Directory',
  success: 'Category moved',
  title: 'Move Category'
});
